import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = "[SAGA_Cart_REDUX]" // eslint-disable-line

const functionDefinitions = {
  /*---------- addCarToCart --------*/
  requestAddCarToCart: ["cars", "routes"],
  addCarToCartSuccess: ["addCarToCartResponse"],
  addCarToCartFailure: ["addCarToCartError"],

  /*---------- openCart --------*/
  requestOpenCart: ["cartVisible"],

  /*---------- ClearCart --------*/
  requestClearCart: [],
  requestClearCar: [],

  /*---------- ClearCart --------*/
  requestAddBookingQueryString: ["bookingQueryString"],
  /*---------- Add Routes --------*/
  requestAddRouteToCart: ["routes"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaCartTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const SagaCartInitState = {
  cartVisible: false,
  cars: [],
  routes: [],
  bookingQueryString: "",
  bookingDate: null
}

export const INITIAL_STATE = Immutable(SagaCartInitState)

/* ------------- Reducers ------------- */
/*---------- addCarToCart --------*/

export const requestAddCarToCart = (state: Immutable, action) => {
  return state.merge({
    addCarToCartFetching: true,
    cars: action.cars,
    routes: action.routes
  })
}
export const requestOpenCart = (state: Immutable, action) => {
  return state.merge({
    cartVisible: action.cartVisible
  })
}
export const requestAddRouteToCart = (state: Immutable, action) => {
  return state.merge({
    routes: action.routes
  })
}
export const requestAddBookingQueryString = (state: Immutable, action) => {
  return state.merge({
    bookingQueryString: action.bookingQueryString,
    bookingDate: new Date()
  })
}
export const requestClearCart = (state: Immutable, action) => {
  return state.merge({
    cars: [],
    routes: [],
    bookingQueryString: "",
    bookingDate: null
  })
}
export const requestClearCar = (state: Immutable, action) => {
  return state.merge({
    // cars: []
  })
}
export const addCarToCartSuccess = (state: Immutable, action) => {
  return state.merge({
    addCarToCartFetching: false,
    addCarToCartResponse: action.addCarToCartResponse,
    addCarToCartError: null
  })
}
export const addCarToCartFailure = (state: Immutable, action) => {
  return state.merge({
    addCarToCartFetching: false,
    addCarToCartError: action.addCarToCartError
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- addCarToCart --------*/
  [Types.REQUEST_OPEN_CART]: requestOpenCart,
  [Types.REQUEST_ADD_ROUTE_TO_CART]: requestAddRouteToCart,
  [Types.REQUEST_CLEAR_CART]: requestClearCart,
  [Types.REQUEST_CLEAR_CAR]: requestClearCar,
  [Types.REQUEST_ADD_BOOKING_QUERY_STRING]: requestAddBookingQueryString,
  [Types.REQUEST_ADD_CAR_TO_CART]: requestAddCarToCart,
  [Types.ADD_CAR_TO_CART_SUCCESS]: addCarToCartSuccess,
  [Types.ADD_CAR_TO_CART_FAILURE]: addCarToCartFailure
})



// WEBPACK FOOTER //
// ./src/redux/sagaCart/sagaCartRedux.ts